import { pushEphemeralTruth, type EphemeralTruth } from '../shared/ephemeral-truth';
import { pingFrame, spotlightFrame, type PresentationContext } from '../janus-engine/presentation/ft3d';
type Row = Record<string, any>;
let lastPingAt = -Infinity;
function context(input: Row): PresentationContext {
    const ft = window.FateTide as Row | undefined;
    const encounterId = String(input.encounter_id ?? '');
    const campaignId = String(input.campaign_id ?? '');
    return { encounterId, campaignId, actorId: String(input.caster_id ?? ''),
        userId: String(ft?.user?.id ?? ''), displayName: String(ft?.user?.username ?? ''), canManage: input.canManage === true,
        encounter: ft?.encounterCache?.get(encounterId) ?? ft?.encounterArr ?? null,
        campaign: ft?.campaignCache?.get(campaignId) ?? ft?.campaignArr ?? null };
}
function send(frame: Row): boolean { return pushEphemeralTruth(frame as EphemeralTruth); }
Object.assign(window, {
    ftPushFt3dPing(request: Row, input: Row): Row {
        const now = Date.now(), frame = pingFrame(context(input), request, now, lastPingAt);
        if (!send(frame)) throw new Error('ping:transport-unavailable');
        lastPingAt = now;
        return frame;
    },
    ftPushFt3dSpotlight(body: Row, input: Row): boolean { return send(spotlightFrame(context(input), body)); },
});
